// French: reference language. Every key must exist here; en.ts and ar.ts
// fall back to it for any missing key.
export default {
  common: {
    loading: "Chargement...",
  },
  header: {
    openMenu: "Ouvrir le menu",
    home: "Accueil",
    language: "Langue",
    searchPlaceholder: "Rechercher une page...",
    searchLabel: "Rechercher une page",
    noResult: "Aucun résultat trouvé",
    notifications: "Notifications",
    notificationsUnread: "Notifications, {count} non lue(s)",
    markAllRead: "Tout marquer comme lu",
    onlyUnread: "Non lues seulement",
    loadMore: "Charger plus",
    viewAllNotifications: "Voir toutes les notifications",
    noNotifications: "Aucune notification",
    onlineAccount: "Compte en ligne",
    myAccount: "Mon compte",
    myProfile: "Mon profil",
    profile: "Profil",
    settings: "Paramètres",
    logout: "Déconnexion",
    roleAdmin: "Admin",
    roleClient: "Client",
    roleDriver: "Livreur",
    roleZoneManager: "Responsable de zone",
    justNow: "À l'instant",
    minutesAgo: "Il y a {n} min",
    hoursAgo: "Il y a {n} h",
  },
  theme: {
    enableLight: "Activer le mode clair",
    enableDark: "Activer le mode sombre",
    light: "Mode clair",
    dark: "Mode sombre",
  },
  sidebar: {
    mainNav: "Navigation principale",
    mainMenu: "Menu principal",
    closeMenu: "Fermer le menu",
    loadingMenu: "Chargement du menu",
  },
  menu: {
    dashboard: "Dashboard",
    trackingDrivers: "Position des livreurs",
    parcels: "Colis",
    parcelsList: "Liste des colis",
    newParcels: "Liste nouveaux colis",
    addParcel: "Nouveau colis",
    inventory: "Inventaire",
    productsList: "Liste des produits",
    stockParcels: "Colis de stock",
    deliveryNotes: "Bons de livraison",
    deliveryStockNotes: "Bons de livraison stock",
    packingStation: "Préparation & emballage",
    parcelReception: "Réception colis",
    sentNotes: "Bons d'envoi",
    distributionNotes: "Bons distribution",
    driverCheck: "Suivi livreur",
    driverInvoices: "Factures livreurs",
    zoneInvoices: "Factures zones",
    returnNotes: "Bons de retour",
    zoneReturns: "Retours zones",
    clientReturns: "Retours clients",
    clientInvoices: "Factures client",
    invoicesList: "Liste des factures",
    newInvoice: "Nouvelle facture",
    transfers: "Virements",
    refunds: "Remboursements",
    customers: "Clients",
    customersList: "Liste des clients",
    newCustomers: "Nouveaux clients",
    verificationCenter: "Centre de vérification",
    ribRequests: "Demandes RIB",
    phoneRequests: "Demandes téléphone",
    claims: "Réclamations",
    exchanges: "Échange",
    driverReturnsFollowup: "Suivi des retours livreurs",
    parcelFollowups: "Colis à suivre",
    pickup: "Ramassage",
    pickupNotes: "Bon de ramassage",
    pickupRequests: "Demandes de ramassage",
    users: "Utilisateurs",
    usersList: "Liste des utilisateurs",
    newDrivers: "Nouveaux livreurs",
    driversStatus: "État des livreurs",
    expenses: "Les dépenses",
    carrierInvoices: "Factures transporteurs",
    transport: "Transport",
    transportsList: "Transports",
    settings: "Paramètres",
    profile: "Profil",
    general: "Général",
    zones: "Zones",
    pricePacks: "Packs tarifaires",
    cities: "Villes",
    agencies: "Agences",
    whatsapp: "WhatsApp",
    ads: "Annonces",
    blackList: "Black liste",
  },
  // Page search in the header
  pages: {
    addCustomer: "Ajouter client",
    addUser: "Ajouter utilisateur",
    pendingDrivers: "Livreurs en attente",
    pickups: "Ramassages",
    receptionNotes: "Bons de réception",
    driverPaymentNotes: "Bons de paiement livreur",
    zonePaymentNotes: "Bons de paiement zone",
    invoices: "Factures",
    stockProducts: "Produits stock",
    verifications: "Vérifications",
    accountSettings: "Paramètres compte",
    statuses: "Statuts",
    clientTypes: "Types clients",
    banks: "Banques",
    transports: "Transports",
    trackingDrivers: "Position des livreurs",
    refundRequests: "Demandes de remboursement",
    pointageNotes: "Bons de pointage",
    addPointage: "Ajouter bon de pointage",
    externDeliveryNotes: "Bons de livraison externes",
    deliveryProviders: "Prestataires de livraison",
    socialLinks: "Réseaux sociaux",
    driverApiDocs: "Documentation API livreur",
    addProduct: "Ajouter produit",
    addDeliveryStockNote: "Ajouter bon de livraison stock",
    addReceptionNote: "Ajouter bon de réception",
    addSentNote: "Ajouter bon d'envoi",
    addGlobalSentNote: "Ajouter bon d'envoi global",
    addDistributionNote: "Ajouter bon de distribution",
    addDriverPayment: "Ajouter bon de paiement livreur",
    addZonePayment: "Ajouter bon de paiement zone",
    addClientReturn: "Ajouter bon de retour client",
    addZoneReturn: "Ajouter bon de retour zone",
    addInvoice: "Ajouter facture",
    addVirement: "Ajouter virement",
    addExpense: "Ajouter dépense",
  },
};
